import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const icons = [
'devicon-javascript-plain colored text-4xl',
'devicon-react-original colored text-4xl',
'devicon-nodejs-plain-wordmark colored text-4xl',
'devicon-nextjs-plain text-4xl',
'devicon-git-plain-wordmark colored text-4xl',
'devicon-tailwindcss-original colored text-4xl',
'devicon-css3-plain colored text-4xl',
'devicon-jasmine-original-wordmark colored text-4xl',
'devicon-mocha-plain colored text-4xl',
'devicon-mysql-plain-wordmark colored text-4xl',
'devicon-mongodb-plain-wordmark colored text-4xl',
'devicon-postgresql-plain-wordmark colored text-4xl',
'devicon-postman-plain colored text-4xl',
'devicon-sequelize-plain-wordmark text-4xl'
]; // Icon list

const Techstack = () => {
  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.1, // Start animation earlier in the viewport
  });

  const [scrollProgress, setScrollProgress] = useState(0);

  // Update scroll progress when the element is in view
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Get current scroll position
      const viewportHeight = window.innerHeight; // Get viewport height
      const elementOffsetTop = ref.current ? ref.current.offsetTop : 0; // Get offset top of element

      // Calculate the relative scroll progress within the viewport (0 to 1)
      const progress = Math.min(
        Math.max((scrollY + viewportHeight - elementOffsetTop) / viewportHeight, 0),
        1
      );
      setScrollProgress(progress); // Update the scroll progress
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [ref]);

  const iconVariants = {
    hidden: (custom) => ({
      opacity: 0,
      x: (Math.random() - 0.5) * 100, // Scatter horizontally (random)
      y: (Math.random() - 0.5) * 400, // Scatter vertically (random)
      scale: 0.5, // Smaller size initially
    }),
    scrollControlled: (custom) => {
      const { progress, index } = custom; // Destructure scroll progress and index
      return {
        opacity: progress,
        x: (1 - progress) * (Math.random() - 0.5) * 400, // Controlled by scroll
        y: (1 - progress) * (Math.random() - 0.5) * 400, // Controlled by scroll
        scale: 0.5 + progress * 0.5, // Grow as scroll progresses
        transition: {
          duration: 3,
          delay: index * 0.2,
          type: 'spring',
          stiffness: 50,
        },
      };
    },
  };

  return (
    <div style={{ height: 'auto', paddingTop: '5vh', marginLeft:'10%' , marginRight:'10%'}}> {/* For scrolling */}
      {/* <motion.h1
            className="myName font-extrabold sm:text-5xl lg:text-7xl lg:py-7"
            initial={{ opacity: 0, y: 20 }} // Initial state
            animate={{ opacity: 1, y: 0 }} // Animated state
            transition={{ duration: 0.6, delay: 0.3 }} // Animation duration and delay
          >
            Techstack
          </motion.h1> */}
      <div ref={ref} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1rem', padding:'30px' }}>
        {icons.map((icon, index) => (
          <motion.div
            key={index}
            custom={{ progress: scrollProgress, index }} // Pass scroll progress and index in one custom object
            initial="hidden"
            animate={inView ? 'scrollControlled' : 'hidden'}
            variants={iconVariants}
          >
            {/* <span style={{ fontSize: '3rem' }}>{icon}</span> */}
            <i className={`${icon} lg:text-7xl`}></i>
            {/* <img src={icon.src} alt={icon.alt} style={{ width: '80px', height: '80px' }} /> Colorful icon */}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Techstack;
